export default __webpack_public_path__ + "static/media/infra-21.22a87a40.webp";